class ThisToysMobileNav extends HTMLElement {
  connectedCallback() {
    this.badge = this.querySelector('[data-tt-mobile-cart-count]');
    this.source = document.querySelector('.header-actions__cart-icon .cart-bubble__text-count');
    this.syncCartCount();

    if (this.source) {
      this.observer = new MutationObserver(() => this.syncCartCount());
      this.observer.observe(this.source.closest('.cart-bubble') || this.source, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
      });
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  syncCartCount() {
    if (!this.badge || !this.source) return;
    const count = Number.parseInt(this.source.textContent?.trim() || '0', 10) || 0;
    this.badge.textContent = count > 99 ? '99+' : String(count);
    this.badge.classList.toggle('tt-mobile-nav__badge--hidden', count < 1);
    this.badge.setAttribute('aria-label', `${count} items in cart`);
  }
}

const nav = document.querySelector('.tt-mobile-nav');
if (nav && !nav.matches(':defined')) {
  const replacement = document.createElement('this-toys-mobile-nav');
  replacement.className = nav.className;
  replacement.setAttribute('aria-label', nav.getAttribute('aria-label') || 'Mobile navigation');
  replacement.innerHTML = nav.innerHTML;
  nav.replaceWith(replacement);
}

if (!customElements.get('this-toys-mobile-nav')) {
  customElements.define('this-toys-mobile-nav', ThisToysMobileNav);
}
